export const LOCAL_STORAGE = 'localStorage'
export const SESSION_STORAGE = 'sessionStorage'

declare global {
  interface WindowEventMap {
    [LOCAL_STORAGE]: CustomEvent
    [SESSION_STORAGE]: CustomEvent
  }
}
